<template>
  <div class="terms-box smbox2">
    <p>Limitations of GPR:
      Some common limitations encountered when using GPR:<br />
      (1) GPR does not measure diameter of objects, just their location. When marking information from
      hyperbolas in line scan mode, allow some margin on each side of the marks.<br />
      (2) GPR should not be performed on areas where standing water is present.
      (3) GPR should not be performed on “green” concrete due to moisture in the slab. Moist or green
      concrete can be troublesome for GPR as moisture will reflect or inhibit the passage of the radar
      pulse thus limiting slab penetration and data quality. This increased conductivity allows the radar
      signal to attenuate (spread-out) and not penetrate into the concrete.<br />
      (4) Relatively uncured concrete is difficult and sometimes impossible to image due to the electrical
      conductivity of the material. Depending on concrete thicknesses and cure time it is recommended
      that no scanning occurs within a minimum of 30 days after pouring. This time may need to be
      adjusted on a case-by-case basis and depending on the signal-to-noise ratio of the GPR system to
      be used.<br />
      (5) Bottom of the slab is sometimes not easy to see in slab-on-grade situations. This is due to the
      interference of the wire mesh and the weak reflection from the concrete-gravel base substrate.
      Obstructions in concrete.<br />
      (6) Targets over targets will prohibit wave propagation to the target below. Closely spaced targets
      may also prohibit the detection of lower embedded targets. Targets under steel targets will be
      difficult to image because the steel target on top will act as a shield preventing the radar from
      hitting the bottom target. Radar will not pass-through steel. Examples; pan deck, tightly spaced
      mesh 4”, multiple layers of offset rebar creating the effect of tightly spaced mesh. Because GPR is usually
      performed
      with one-side access, additional targets may lie in the “shadow” of targets nearer to the surface. Items such as
      conduits and post-tension cables may be directly underneath rebar and cannot be imaged with GPR.<br />
      (7) A limitation distance adjacent to an obstruction (2-4” from walls, conduits, studs, etc.) is present with
      GPR devices due to the orientation of the internal transmitter/receiver. Each limitation is unique to the
      specific devices of individual manufacturers. <br />
      (8) Each GPR antenna or antenna array cannot image through
      metal
      wire mesh/metal fiber with specified spacing (i.e., chicken wire mesh, terrazzo flooring). Consult with the
      manufacturer to determine these limitations specific to each antenna. <br />
      (9) GPR cannot image through foam used
      within slabs or on roofs. On roofs, these areas need to be opened up by a qualified individual a minimum of 1
      foot larger on all sides than the intended scanned area. For example, a required scan area of 2-foot x 2-foot
      should be opened to at least a 4-foot x 4-foot area. Foam placed internally in a slab requires scanning from
      both sides of the deck. <br />
      (10) Ability to image on the opposing side of air voids in concrete (i.e., hollow
      core
      slabs, CMU block walls) cannot be performed. Access to the opposite side is required to complete the scan. Air
      voids can be seen but will not allow the radar pulse to reconnect with the slab and continue generating data.
      Typically, anything over 1⁄2 air void will cause an issue with collecting data deeper. <br />
      (11) Locating metal and
      PVC conduits in the “valleys” of corrugated steel decks is difficult and, in some circumstances, impossible.
      Efforts should be made to avoid drilling into these “valleys”. Pan decking will not allow radar to pass through
      it. The reflecting glow of the radar energy thus hides metallic or PVC targets in the low part of the pan. Avoid
      drilling in lower sections of pan decking.<br />
      (12) Interference from cell phones or other radio frequencies can
      make the scan image poor. (Limitations References: Concrete Structure Investigations, The Concrete Sawing and
      Drilling Association & Hilti) Limitations when operating in GPR scanned slabs / Tolerance Zones and Setback
      Guidelines Note: SafeCore modified setbacks / tolerance zones in suspended slabs (adding 1.25”, 1.5” & 2”
      tolerance zone options to the CSDA 1” recommended setback from the edge of the marked embedment) to reduce the
      risk of damages to PT cables, structural steel, conduits or any embedded utility. Additional modifications were
      made to CSDA broad based tolerance zone setback guidelines for slab on grade applications. After extensive field
      testing, the SafeCore slab on grade setback tolerance zones were established and modified in relation to slab
      thickness for slab on grade applications. 1.1. Core Drilling Specific: GPR does not measure the diameter of
      objects, just their location. Allow at least a 2” setback from center of the marked embedment or 1” setback from
      the edge of the marking, whichever is greater, to the closest point of core drilling. Refer to the SafeCore GPR
      Technician Guidebook for the marking of setbacks in relation to the marked embedments. 1.2. Sawing Specific:
      1.2.1. GPR does not measure the diameter of objects, just their location. Allow a minimum of a 6” setback (12”
      wide) from the center of a target in 4” slabs, a minimum of a 9” setback (18” wide) from the center of a target
      in 5-6” slabs and a minimum of a 12” setback (24” wide) in slabs in excess of 6” on each side of the marked
      target to the closest point of sawing. A partial depth cut may be utilized in the setback area if the depth of
      embedment is indicated. It is recommended that your depth of cut be at least 3” above the marked-out depth.
      Refer to the SafeCore GPR Technician Guidebook for the marking of setbacks in relation to the marking of slab on
      grade embedments. 1.2.2. Use caution when sawing in slab on grade as bottom of slab typically varies and GPR
      scanning can be difficult to interpret in slab-on-grade situations. This is due to the interference of the wire
      mesh and the weak reflection from the concrete-gravel base interface. It is important to verify the thickness of
      the slab on grade to avoid cutting into subgrade as conduits are typically laid on top of subgrade. Methods
      which assist in determining slab depth include: having the GPR scanner mark for bottom of slab, roto-hammering
      test holes on a regular interval, or visual evidence of different slab thicknesses. Note differences in GPR
      marked depths vs actual depths, i.e., if the concrete is marked at 6” thick and the actual saw cut depth is
      measured 5” concrete, adjust all GPR depths by the same distance. 1.3. Hand Breaking Specific: GPR does not
      measure the diameter of objects, just their location. Allow at least a 2” setback from the center of the marked
      embedment or 1.25” setback from the edge of the marking, whichever is greater, to the closest point of breaking.
      Take into consideration the potential targets in a setback area to determine size, impact and chisel point type.
      Refer to the SafeCore GPR Technician Guidebook for the marking of embedments. 1.4. A limitation distance
      adjacent to an obstruction (walls, conduits, studs, etc.) is present with GPR devices due to the orientation of
      the internal transmitter/receiver. Each limitation is unique to the specific devices of individual
      manufacturers. It is recommended that operators maintain a 2-4” or more setback when operating near a vertical
      obstruction. Take into consideration the potential targets in a setback area to determine size, impact and
      chisel point type. 1.5. The operator must be aware that locating metal and PVC conduits in the “valleys” of
      corrugated steel decks are difficult and, in some circumstances, impossible. Efforts should be made to avoid
      core drilling into these “valleys”. 1.6. The operator must be aware that a GPR antenna or antenna array cannot
      image through metal wire mesh/metal fiber with specified spacing (i.e., chicken wire mesh). Consult with the GPR
      scanner to determine these limitations specific to the manufacturer antenna they utilize. 1.7. The operator must
      be aware that GPR cannot image through foam used within slabs or on roofs. On roofs, these areas need to be
      opened by a qualified individual a minimum of 1 foot larger on all sides than the intended scanned area. For
      example, a required scan area of 2-foot x 2-foot should be opened to at least a 4-foot x 4-foot area. Foam
      placed internally in a slab requires scanning from both sides of the deck. 1.8. Ability to image on opposing
      sides of air voids in concrete (i.e., hollow core slabs, CMU block walls) cannot be performed. Access to the
      opposite side is required to complete the scan. 1.9. The operator must be aware that relatively uncured concrete
      is difficult and sometimes impossible to image due to the electrical conductivity of the material. Depending on
      concrete thicknesses and cure time it is recommended that no scanning occur within a minimum of 30 days after
      pouring. This time may need to be adjusted on a case-by-case basis. (Reference: Operating in GPR Scanned Slabs
      Issue No.: CSDA-BP-026 Effective Date: May 13, 2020.) Copyright 2023
    </p>
  </div>
</template>
<script>
// import SigPad from "@/pages/Dashboard/ProjectPages/Components/SigPad.vue";
export default {
  components: {
    // SigPad
  },
  data() {
    return {}
  }
}
</script>
<style lang="scss">
.terms-box {
  border: 1px solid gray;
  height: 200px;
  overflow-y: scroll;
  width: 100%;

  p {
    padding: 5px 10px;
    padding-top: 0;
  }
}

.smbox {
  width: 50%;
  margin-right: 15px;
  margin-top: 5px;
}
</style>
